import { render } from "./Footer.vue?vue&type=template&id=c3141b36&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=c3141b36&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\Downloads\\ASKNC-Website\\asknc-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3141b36"]])

export default __exports__